// Intercom init snippet adapted from,
// https://app.intercom.io/a/apps/flf45u7a/guide/web_integration/web_integration_users#

export function addTemporaryIntercomGlobal() {
  let w = window;
  let ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    // Intercom already activated.
    // Will update after getting user info.
    //ic('update', intercomSettings);
    return;
  }

  // Create temporary window.Intercom to queue up requests before script loaded
  let i = function () {
    i.c(arguments);
  };
  i.q = [];
  i.c = function (args) {
    i.q.push(args);
  };
  w.Intercom = i;

  return w.Intercom;
}

export function addIntercomScript(intercomioAppId) {
  let d = document;
  let w = window;
  // Load Intercom after window resources loaded
  function l() {
    let s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${intercomioAppId}`;
    let x = d.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  }
  // Check to see if load event may have already fired.
  // The snippet wasn't doing this check but it was assuming a deployment of this code
  // statically in document.head. This was leading to timing windows where Intercom
  // wasn't being loaded.
  if (d.readyState === 'complete') {
    // DOM already loaded - load Intercom now
    l();
  } else {
    // Wait for DOM to finish loading
    w.addEventListener('load', l, false);
  }
}
